import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge conditional class names and resolve conflicting Tailwind utility
 * classes (e.g. `p-2` vs `p-4`) in favor of the last one supplied.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
